import React from 'react';
import {
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
    PlusCircleOutlined,
    MenuUnfoldOutlined,
    SwapOutlined,
} from '@ant-design/icons';
import { Dropdown, MenuProps, Space } from 'antd';
import { DEFAULT_ACTIONS_LABEL } from '../admin-knowledge-base.constants';
import { memo } from 'react';

export enum ControlType {
    CREATE = 'create',
    EDIT = 'edit',
    DELETE = 'delete',
    VIEW = 'view',
    MOVE = 'move',
}

export const iconsMap: Record<ControlType, JSX.Element> = {
    create: <PlusCircleOutlined />,
    delete: <DeleteOutlined />,
    edit: <EditOutlined />,
    view: <EyeOutlined />,
    move: <SwapOutlined />,
};

export type ControlsProps = {
    items: MenuProps['items'];
    noLabel?: boolean;
    label?: string;
};

const Controls: React.FC<ControlsProps> = memo(({ items, label, noLabel }) => (
    <Dropdown
        menu={{ items }}
        trigger={['click']}
    >
        <a
            onClick={(e) => e.stopPropagation()}
            className="controls"
        >
            <Space>
                <MenuUnfoldOutlined />
                {!noLabel && <span>{label || DEFAULT_ACTIONS_LABEL}</span>}
            </Space>
        </a>
    </Dropdown>
));

export default Controls;
